import React, {useRef} from 'react';
import cx from 'classnames';
import store from 'javascripts/store.js';
import {Observer} from 'mobx-react';

const Button = ({classes, text, onClick}) => {
  const submitButton = useRef(null);

  const handleClick = (event) => {
    submitButton.current.blur();
    onClick(event);
  };

  return (
    <Observer>
      {() =>  (
        <button
          className={cx('w-full', classes)}
          disabled={store.donateForm.disableFormSubmit}
          id='donate-button'
          onClick={handleClick}
          ref={submitButton}
        >
          {text}
        </button>
      )}
    </Observer>
  );
};

export default Button;
